import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getReportMemberMaintenance } from "../../service/admin";

const initialState = {
  adminStatus: { apiErr: "", apiSuccess: "", dialog: false },
};

export const admin = createAsyncThunk(
  "admin/memberMaintenance",
  async (action) => {
    if (action.condition === "getReportMemberMaintenance") {
      const response = await getReportMemberMaintenance(action.payload);
      return response;
    } else {
      throw new Error("Unknown action condition");
    }
  }
);

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    clearErr: (state) => {
      state.adminStatus.apiSuccess = "";
      state.adminStatus.apiErr = "";
      state.adminStatus.dialog = false;
      state.resetPassword.apiSuccess = "";
      state.resetPassword.apiErr = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(admin.fulfilled, (state, action) => {
        if (action.payload.API_Name === "getReportMemberMaintenance") {
          return "";
        }
        state.loading = false;
      })
      .addCase(admin.pending, (state) => {
        state.loading = true;
        return state;
      })
      .addCase(admin.rejected, (state, action) => {
        state.searchstatusError = action.error.message;
        state.adminStatus.apiSuccess = "";
        state.adminStatus.dialog = true;
        state.resetPassword.apiErr = action.error.message;
        state.adminStatus.apiErr = action.error.message;
        state.loading = false;
        state.searchMembersList = [];
        return state;
      });
  },
});

export const { clearErr } = adminSlice.actions;
export default adminSlice.reducer;
